namespace $.$$ {
	export class $shm_mentionstat_form extends $.$shm_mentionstat_form {
		query_bid() { return this.query().trim() ? '' : '*' }
		files_bid() { return this.social_title() || this.mass_title() ? '' : '*' }
		social_title() { return this.social_files()[0]?.name || this.social_existing_title() }
		mass_title() { return this.mass_files()[0]?.name || this.mass_existing_title() }
		submit_allowed() { return !this.files_bid() }
	}
}
